import React, {useCallback, useEffect, useState} from "react";
import ReactDOM from 'react-dom';
import {createRoot} from "react-dom/client";
import {ModalWindow} from "./ModalWindow";
import {Cancel, Edit, Save} from "@mui/icons-material";
import {Button, Tooltip} from "@mui/material";
import {useBlocker} from "./usePrompt";

export function DiaConfirmation(message,callback) {
    const [root,setRoot] = useState(null);
    console.log('DIACONFIRM');
    useEffect(()=> {
        const container = document.createElement("div");

        //container.setAttribute("custom-confirmation-navigation", "");
        document.body.appendChild(container);
        const root = createRoot(container); // createRoot(container!) if you use TypeScript
        setRoot(root);
        return (()=>{
            document.body.removeChild(container);
        })
    },[]);
    const confirm = ()=>{
        ReactDOM.unmountComponentAtNode(root);
        document.body.removeChild(root);
        callback(false);
    }
    const cancel = ()=>{
        ReactDOM.unmountComponentAtNode(root);
        document.body.removeChild(root);
        callback(false);
    };
    const skip = ()=>{
        ReactDOM.unmountComponentAtNode(root);
        document.body.removeChild(root);
        callback(true);
    };
    return root.render(
        <ModalWindow isOpen={true} onClose={cancel} header={
            <h3>Changes Pending</h3>
        } actions={
            <>
            <Tooltip title="Discard changes"><Button size="large" color="warning" onClick={skip} startIcon={<Cancel/>}>Discard</Button></Tooltip>
            <Button size="large" color="primary" onClick={confirm} startIcon={<Save/>}>Save</Button>
            </>
        }>
            {message}
        </ModalWindow>
    );
/*        <Dialog title="Changes pending" isOpen={true} onConfirm={confirm} intent="primary" onClose={cancel} className='confirm-dialog'>
        <div className={Classes.DIALOG_BODY}>
        </div>
        <div className={Classes.DIALOG_FOOTER}>
            <div className={Classes.DIALOG_FOOTER_ACTIONS+' split-buttons'}>
            </div>
        </div>
    </Dialog>);*/
}

type Callback = ()=>void;

type DiaPromptConfirmationArgs = {
    isActive:boolean,
    discard:Callback,
    save:Callback,
    returnToEdit:Callback,
    saveFailed:boolean
}

/**
 * Prompts the user with an Alert before they leave the current screen.
 *
 * @param  message
 * @param  when
 */
export function usePrompt( message, when = true ) {
    const blocker = useCallback(
        ( tx ) => {
            // eslint-disable-next-line no-alert
            if ( window.confirm( message ) ) tx.retry();
        },
        [ message ]
    );
    useBlocker( blocker, when );
}

export function DiaPromptConfirmation(props:DiaPromptConfirmationArgs) {
    console.log('DIACONFIRM- PROMPT',props);
    if(props.saveFailed) {
        // save failed :(
        return (<ModalWindow isOpen={props.isActive} onClose={props.returnToEdit} header={
            <h3>Save Failed</h3>
        } actions={
            <>
            <Tooltip title="Return to editing"><Button size="large"  color="warning" onClick={props.returnToEdit} startIcon={<Edit/>}>Continue editing</Button></Tooltip>
            <Tooltip title="Discard changes and leave"><Button size="large" color="error" onClick={props.discard} startIcon={<Cancel/>}>Discard changes</Button></Tooltip>
            </>
        }>
            <div>Unable to save, please correct any errors or discard your changes and continue.</div>
        </ModalWindow>);
/*
            return <Dialog title="" isOpen={isActive} onConfirm={confirm} intent="danger" onClose={cancel} className='confirm-dialog'>
            <div className={Classes.DIALOG_BODY}>
            </div>
            <div className={Classes.DIALOG_FOOTER}>
              <div className={Classes.DIALOG_FOOTER_ACTIONS}>
              </div>
            </div>
        </Dialog>;*/
    }
    return (<ModalWindow isOpen={props.isActive} onClose={props.returnToEdit} header={
        <h3>Changes pending</h3>
    } actions={
        <>
            <Tooltip title="Discard changes"><Button size="large" color="warning" onClick={props.discard} startIcon={<Cancel/>}>Discard</Button></Tooltip>
            <Button size="large" color="primary" onClick={props.save} startIcon={<Save/>}>Save</Button>
        </>
    }>
        <div>You have outstanding changes, please save the changes before leaving.</div>
    </ModalWindow>);
}


export default DiaConfirmation;